import { useState } from "react";
import { createRoute, useNavigate } from "@tanstack/react-router";
import type { HomeFrame } from "@amber/application/contracts";
import { AppFrame } from "../shell/AppFrame";
import { usePageTitle } from "../shell/title";
import { HomeStatus, HomeTopbar, HomeView } from "../views/home/Home";
import { homeSearchSchema } from "../views/home/search";
import { rootRoute } from "./root";

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  validateSearch: homeSearchSchema,
  component: function HomeRoute() {
    usePageTitle("Home");
    const frame: HomeFrame = homeRoute.useSearch().frame ?? "7d";
    const navigate = useNavigate({ from: "/" });
    const [team, setTeam] = useState(false);
    const onFrame = (next: HomeFrame) => {
      void navigate({ search: { frame: next === "7d" ? undefined : next } });
    };
    return (
      <AppFrame
        view="Home"
        status={<HomeStatus frame={frame} team={team} />}
        topbar={
          <HomeTopbar
            frame={frame}
            team={team}
            onFrame={onFrame}
            onTeam={() => {
              setTeam(true);
            }}
          />
        }
      >
        {() => <HomeView frame={frame} onFrame={onFrame} team={team} onTeam={setTeam} />}
      </AppFrame>
    );
  },
});
